import * as Yup from 'yup';

Yup.setLocale({
  mixed: {
    required: 'Campo obrigatório',
  },
  string: {
    email: 'Preencha um e-mail válido',
    min: 'Mínimo de ${min} caracteres',
    max: 'Máximo de ${max} caracteres',
  },
  number: {
    min: 'Deve ser maior ou igual a ${min}',
    max: 'Deve ser menor ou igual a ${max}',
  },
});

const Schema = Yup.object().shape({
  initialData: Yup.array().of(
    Yup.object().shape({
      description: Yup.string().required(),
      solution: Yup.string().required(),
      id_contract_item: Yup.number().required(),
      started_at: Yup.string().required(),
      cause: Yup.string().required(),
    })
  )
});
export default Schema;